
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as successbb2HmaztMe8tGtjjLR_hVh4hGNH_45AwpDPHcjkE1WtpUMeta } from "/opt/buildhome/repo/pages/success.vue?macro=true";
import { default as dev_45toolsEW5Z4Ge0EBmpXmeYMFvIXLtIqQYf64SYhGrMfwQDecsMeta } from "/opt/buildhome/repo/pages/dev-tools.vue?macro=true";
import { default as maintenanceoEAAbYRQxlg3KkwOcc9v46V1RFGkzARoJn5IbuU81fkMeta } from "/opt/buildhome/repo/pages/maintenance.vue?macro=true";
import { default as _91token_93nxl1ssca0msy2uSg5wHnF9zluPjK1IDXn6voRDAQAbsMeta } from "/opt/buildhome/repo/pages/[type]/[token].vue?macro=true";
import { default as unauthorizedmsMbJkBKXeLC2K3q4apGZbWE_WjzO5Y2pO_yvge_CFAMeta } from "/opt/buildhome/repo/pages/errors/unauthorized.vue?macro=true";
import { default as already_submittedPOOlacFfLYfSP4nwT9oFqiMrRfdGV0meaKS5gsJFHwoMeta } from "/opt/buildhome/repo/pages/errors/already_submitted.vue?macro=true";
import { default as already_instructedUmvBNmjdz_bZLubjVLoEFWK9RyERZvxDBxXW5nJs9FsMeta } from "/opt/buildhome/repo/pages/errors/already_instructed.vue?macro=true";
import { default as _91token_9307A90uPfTFAriBsDAE6mWrQE1bgQisaNWoOjnY0NZhQMeta } from "/opt/buildhome/repo/pages/additional-enquiries-done/[token].vue?macro=true";
import { default as _91token_93DvD0rJNWmidRcfMebHz8ncXMmaJ0O4tCsQ1ZJn97uzUMeta } from "/opt/buildhome/repo/pages/additional-enquiries-guidance/[token].vue?macro=true";
import { default as _91token_936Hglk0ixX_THE_cJZJ_459XvXq0zZ1TzVzpT1mbWyU6pQMeta } from "/opt/buildhome/repo/pages/additional-enquiries-signed-off/[token].vue?macro=true";
import { default as _91token_93Va1ifenAqxhu1yRYvMXIvsKDIbsvd6VuAiq8ROH_J4oMeta } from "/opt/buildhome/repo/pages/additional-enquiries-blocking-exchange/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/opt/buildhome/repo/pages/success.vue")
  },
  {
    name: "dev-tools",
    path: "/dev-tools",
    component: () => import("/opt/buildhome/repo/pages/dev-tools.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/opt/buildhome/repo/pages/maintenance.vue")
  },
  {
    name: "type-token",
    path: "/:type()/:token()",
    meta: {"middleware":["check-form-type","check-form-token"]},
    component: () => import("/opt/buildhome/repo/pages/[type]/[token].vue")
  },
  {
    name: "errors-unauthorized",
    path: "/errors/unauthorized",
    component: () => import("/opt/buildhome/repo/pages/errors/unauthorized.vue")
  },
  {
    name: "errors-already_submitted",
    path: "/errors/already_submitted",
    component: () => import("/opt/buildhome/repo/pages/errors/already_submitted.vue")
  },
  {
    name: "errors-already_instructed",
    path: "/errors/already_instructed",
    component: () => import("/opt/buildhome/repo/pages/errors/already_instructed.vue")
  },
  {
    name: "additional-enquiries-done-token",
    path: "/additional-enquiries-done/:token()",
    meta: {"middleware":["check-form-token"]},
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries-done/[token].vue")
  },
  {
    name: "additional-enquiries-guidance-token",
    path: "/additional-enquiries-guidance/:token()",
    meta: {"middleware":["check-form-token"]},
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries-guidance/[token].vue")
  },
  {
    name: "additional-enquiries-signed-off-token",
    path: "/additional-enquiries-signed-off/:token()",
    meta: {"middleware":["check-form-token"]},
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries-signed-off/[token].vue")
  },
  {
    name: "additional-enquiries-blocking-exchange-token",
    path: "/additional-enquiries-blocking-exchange/:token()",
    meta: {"middleware":["check-form-token"]},
    component: () => import("/opt/buildhome/repo/pages/additional-enquiries-blocking-exchange/[token].vue")
  }
]